import { filter } from 'rxjs/operators';
import { ProductGroupModel, ProductModel } from '../../../model/product.model';
import { F7ComponentContext, F7Page } from '../../../types/framework7-types';
import { Router } from 'framework7/build/core/modules/router/router';
import { BaseComponent, ComponentState } from '../../../lib/base-component';
import { RootServices } from '../../../services/root.services';
import { ChatRoom } from '../../../lib/nam-chat/chat-room';
import { CommonService } from '../../../services/common.service';
import { TaskReminderModel } from '../../../model/task.model';
import { BehaviorSubject } from 'rxjs';
import { Dialog } from 'framework7/build/core/components/dialog/dialog';
import { Chart, registerables } from 'chart.js';
import { AccMasterBookModel } from '../../../../../src/app/model/accounting.model';
import { SmartSelect } from 'framework7/build/core/components/smart-select/smart-select';
import { Calendar } from 'framework7/build/core/components/calendar/calendar';
import { Autocomplete } from 'framework7/build/core/components/autocomplete/autocomplete';
// import * as $ from 'jquery';
declare const $: any;

// declare const $: any;
export interface ComponentStateExtend extends ComponentState {
  [key: string]: any;
  instance: F7ComponentContextExtend,
  // voucher?: CommercePosOrderModel;
  // vouchers?: CommercePosOrderModel[];
  reportQuery?: { productGroups?: string[], type?: string, range?: Date[], unit?: any, product?: any },

  reportForm?: {
    ReportType?: SmartSelect.SmartSelect,
    Range?: Calendar.Calendar,
    Product?: Autocomplete.Autocomplete,
    Unit?: SmartSelect.SmartSelect,
  },

  reportTypeList?: { id: string, text: string, reportType?: string, range: Date[] }[],
  reportType?: string,



}

export class F7ComponentContextExtend extends F7ComponentContext {
  // messagebar?: F7Messagebar;
  // messages?: Messages.Messages;
  // images?: string[];
  responseInProgress?: boolean;
  // answers?: string[];
  // people?: { name?: string, avatar?: string }[];
  // hideToolbar?: () => void;
  // sheetToggle?: () => void;
  // deleteAttachment?: (e: MouseEvent, index: number) => void;
  // handleAttachment?: (e: MouseEvent) => void;
  // checkAttachments?: () => void;
  // sendMessage?: () => void;

  detailDialog?: Dialog.Dialog;

  $root: any;
  $route: Router.Route & { context?: { backTitle?: string, title?: string, largeTitle?: string, reminder?: TaskReminderModel, chatRoom?: ChatRoom, reminderList$?: BehaviorSubject<TaskReminderModel[]> } };
}

/** Component group manager */
export class PurchasePriceStatisticsComponent extends BaseComponent<ComponentStateExtend> {
  // states: { [key: string]: State } = {};

  title: 'Purchase Price Statistics'
  stateMap = {
    NOTJUSTAPPROVED: {
      label: 'Chưa duyệt',
      status: 'warning',
    },
    APPROVED: {
      label: 'Đã duyệt',
      status: 'success',
    },
  };

  masterBook: AccMasterBookModel = null;
  costAndRevenueStatisticsData: {};
  reportDate = new Date();

  dateReportList = [
    { id: 'DAY', text: 'Phân tích theo ngày', range: [new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0), new Date(new Date().getFullYear(), new Date().getMonth(), 31, 23, 59, 59)] },
    { id: 'MONTH', text: 'Phân tích theo tháng', range: [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31)] },
    { id: 'DAYOFWEEK', text: 'Phân tích theo tuần', range: [this.getUpcomingMonday(), this.getUpcomingSunday()] },
    { id: 'HOUR', text: 'Phân tích theo giờ', range: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59)] },
  ];

  constructor(
    public rootServices: RootServices,
    public commonService: CommonService,
  ) {
    super(rootServices);
    // // console.log('Click here to open ts file');
    Chart.register(...registerables);
  }

  getUpcomingMonday() {
    const date = new Date();
    const today = date.getDate();
    const dayOfTheWeek = date.getDay();
    const newDate = date.setDate(today - dayOfTheWeek + 1);
    const result = new Date(newDate);
    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    return result;
  }
  getUpcomingSunday() {
    const date = new Date();
    const today = date.getDate();
    const dayOfTheWeek = date.getDay();
    const newDate = date.setDate(today - dayOfTheWeek + 7);
    const result = new Date(newDate);
    result.setHours(23);
    result.setMinutes(59);
    result.setSeconds(59);
    return result;
  }

  onF7pageRemove(chatRoomId: string) {
    // if (this.chatRoomCacheList[chatRoomId]) {
    //   this.chatRoomCacheList[chatRoomId].disconnect();
    // }
  }

  prepareItem(p: ProductModel) {
    p.DateOfOrderText = this.rootServices.datePipe.transform(p.DateOfOrder, 'short');
    p.StateLabel = this.stateMap[p.State]?.label || 'Unknow';
    p.StateStatus = this.stateMap[p.State]?.status || 'primary';
    return p;
  }

  async getList(params: any) {
    // console.log(self.searchBar);
    // return this.rootServices.apiService.getPromise<any[]>('/purchase/order-vouchers', {
    //   includeCreator: true,
    //   includeRelativeVouchers: true,
    //   sort_Id: 'desc',
    //   limit: 10,
    //   offset: 0,
    //   ...params,
    // });
    return [];
  }

  dayOfWeekMap = {
    1: 'cn',
    2: 't2',
    3: 't3',
    4: 't4',
    5: 't5',
    6: 't6',
    7: 't7',
  };
  makeStaticLabel(item: any, reportType: string) {
    if (reportType === 'MONTH') {
      return (item['Month']).toString().padStart(2, "0") + '/' + (item['Year']).toString().padStart(2, "0");
    }
    if (reportType === 'DAY') {
      return (item['Day']).toString().padStart(2, "0") + '/' + (item['Month']).toString().padStart(2, "0");
    }
    if (reportType === 'HOUR') {
      return (item['Hour']).toString().padStart(2, "0");
    }
    // return (item['DayOfWeek']).toString().padStart(2, "0");
    return this.dayOfWeekMap[item['DayOfWeek']];
  }

  makeTimeline(item: any, reportType: string) {
    if (reportType === 'MONTH') {
      return (item['Year']).toString().padStart(2, "0") + '/' + (item['Month']).toString().padStart(2, "0");
    }
    if (reportType === 'DAY') {
      return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0");
    }
    if (reportType === 'HOUR') {
      return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0") + '/' + (item['Hour']).toString().padStart(2, "0");
    }
    return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0");
  }

  // On component init
  async onComponentInit(state: ComponentStateExtend, index: string, asCase?: string, f7Page?: F7Page) {
    const currentState = await super.onComponentInit(state, index, asCase, f7Page);
    currentState.reportType = 'MONTH';
    currentState.reportForm = {};
    // const ctx = $('#myChart');

    // Load statistic data for purchase activity
    await this.rootServices.apiService.getPromise<AccMasterBookModel[]>('/accounting/master-books/current', {}).then(rs => {
      this.masterBook = rs[0];
      const current = new Date();
      const previousMonth = new Date(current.getTime() - 31 * 24 * 60 * 60 * 1000);
      let previousYear = new Date();
      previousYear.setFullYear(previousYear.getFullYear() - 1);
      let fromDate = new Date(this.masterBook.DateOfBeginning);
      currentState.reportTypeList = [
        { id: 'DAY', reportType: 'DAY', text: '30 ngày gần nhất', range: [new Date(previousMonth.getFullYear(), previousMonth.getMonth(), previousMonth.getDate(), 0, 0, 0), current] },
        { id: 'MONTH', reportType: 'MONTH', text: '12 tháng gần nhất', range: [new Date(previousYear.getFullYear(), previousYear.getMonth(), previousYear.getDate()), current] },
        { id: 'FROMOPENED', reportType: 'MONTH', text: 'Đầu kỳ đến hiện tại', range: [new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()), current] },
        { id: 'DAYOFWEEK', reportType: 'DAYOFWEEK', text: 'Các ngày trong tuần', range: [this.getUpcomingMonday(), this.getUpcomingSunday()] },
        { id: 'HOUR', reportType: 'HOUR', text: '24 giờ trong ngày', range: [new Date(current.getFullYear(), current.getMonth(), current.getDate(), 0, 0, 0), new Date(current.getFullYear(), current.getMonth(), current.getDate(), 23, 59, 59)] },
      ];
      // currentState.instance.$setState({
      //   reportTypeList: currentState.reportTypeList
      // });
    });

    // await this.rootServices.apiService.getPromise<ProductGroupModel[]>('/admin-product/groups', { onlyIdText: true }).then(rs => {
    //   currentState.instance.productGroupList = rs;
    // });
    await this.rootServices.apiService.getPromise<ProductGroupModel[]>('/admin-product/units', { onlyIdText: true, limit: 'nolimit' }).then(rs => {
      currentState.instance.unitList = rs;
    });


    
    currentState.reportQuery = { productGroups: [], type: currentState.reportType, range: currentState.reportTypeList.find(f => f.id == currentState.reportType)?.range };
    

    currentState.reportForm.ReportType = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="ReportType"]').closest('.smart-select') as any);
    currentState.reportForm.Unit = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="Unit"]').closest('.smart-select') as any);
    currentState.reportForm.Range = currentState.instance.$f7.calendar.create({
      inputEl: '[name="ReportRange"]',
      dateFormat: 'd/m/yyyy',
      rangePicker: true,
      closeOnSelect: true,
      on: {
        change(calendar, value: Date[]) {
          console.log(calendar, value);
          if (value && value.length == 2) {
            currentState.instance.refresh();
          }
        },
      }
    });

    currentState.reportForm.Product = this.createAutocompleteField($(f7Page.el).find('.autocomplete.Product')[0], currentState, (query) => {
      return this.rootServices.apiService.getPromise<ProductModel[]>('/admin-product/products', { search: query, includeIdText: true, limit: 100 });
    }, async (value) => {
      const product = await this.rootServices.apiService.getPromise<ProductModel[]>('/admin-product/products/' + this.commonService.getObjectId(value[0]), { includeUnitConversions: true }).then(rs => rs[0]);
      currentState.reportQuery.product = value[0];
      currentState.instance.$setState({
        Product: value[0],
        unitList: product.UnitConversions || [],
      });
    }, (value) => {
      currentState.instance.refresh();
    }, {});


    currentState.reportForm.ReportType.on('change' as any, (smartSelect, value) => {
      console.log(smartSelect, value);
      currentState.reportQuery.type = value;
      currentState.reportQuery.range = currentState.reportTypeList.find(f => f.id == currentState.reportQuery.type)?.range;
      currentState.reportForm.Range.setValue(currentState.reportQuery.range);
    });
    currentState.reportForm.Unit.on('change' as any, (smartSelect, value) => {
      console.log(smartSelect, value);
      currentState.reportQuery.unit = value;
      currentState.instance.refresh();
    });

    // Init filter
    if(currentState.instance?.$route?.context && currentState.instance?.$route?.context['product']) {
      currentState.reportQuery.product = currentState.instance?.$route?.context['product'];
    }

    currentState.instance.$setState({
      reportTypeList: currentState.reportTypeList,
      productGroupList: currentState.instance.productGroupList,
      unitList: currentState.instance.unitList,
      Product: currentState.reportQuery.product,
      Unit: currentState.reportQuery.unit,
    });
    // End init filter
    
    setTimeout(() => {
      currentState.reportForm.Range.setValue(currentState.reportQuery.range);
      currentState.reportForm.ReportType.setValue(currentState.reportType);
      if(currentState.instance?.$route?.context && currentState.instance?.$route?.context['unit']) {
        currentState.reportQuery.unit = currentState.instance?.$route?.context['unit'];
        currentState.reportForm.Unit.setValue(this.commonService.getObjectId(currentState.reportQuery.unit));
      }
    }, 300);

    return currentState;
  }

  get f7Component(): Router.RouteParameters {
    const $this = this;
    return {
      name: 'purchase-price-statistics',
      path: '/purchase/price-statistics',
      component: {
        template: /*html*/`
            <div class="page purchase-price-statistics" data-name="purchase-price-statistics">
              <div class="navbar">
                <div class="navbar-bg"></div>
                <div class="navbar-inner sliding">
                  <div class="left">
                    <a class="link back {{textColorClass}}">
                      <i class="icon icon-back"></i>
                      <span class="if-not-md {{textColorClass}}">{{js "this.backTitle || 'Back'"}}</span>
                    </a>
                  </div>
                  <div class="title">Purchase Price Statistics</div>
                  <div class="right">
                    <!-- Link to enable searchbar -->
                    <a class="link icon-only searchbar-enable {{textColorClass}}" data-searchbar=".inventory-adjust-note-list-searchbar">
                      <i class="icon f7-icons if-not-md">search</i>
                      <i class="icon material-icons md-only">search</i>
                    </a>
                  </div>
                  <!-- Searchbar is a direct child of "navbar-inner" -->
                  <form class="searchbar inventory-adjust-note-list-searchbar searchbar-expandable">
                    <div class="searchbar-inner">
                      <div class="searchbar-input-wrap">
                        <input type="search" placeholder="Search" />
                        <i class="searchbar-icon"></i><span class="input-clear-button"></span>
                        
                      </div>
                      <span class="searchbar-disable-button {{textColorClass}}">Hủy</span>
                    </div>
                  </form>
                </div>
              </div>
              <div class="page-content ptr-content" @ptr:refresh="refresh" data-ptr-distance="80">
                <div class="ptr-preloader">
                  <div class="preloader"></div>
                  <div class="ptr-arrow"></div>
                </div>
                <div class="searchbar-backdrop product-list-backdrop"></div>

                <!--<div class="block" style="margin-top: 1rem; margin-buttom: 0.3rem">
                  <div class="row">
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-primary);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-blue">
                                <i class="icon f7-icons">chart_bar_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Mua hàng</div>
                              <div class="label-value">{{summaryReportData.PurchaseAmount}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-warning);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-orange">
                                <i class="icon f7-icons">arrow_down_right_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Chi phí</div>
                              <div class="label-value">{{summaryReportData.PurchaseCost}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-success);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-green">
                                <i class="icon f7-icons">graph_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Chiết khấu</div>
                              <div class="label-value">{{summaryReportData.GrossProfit}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-danger);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-red">
                                <i class="icon f7-icons">creditcard</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Công nợ</div>
                              <div class="label-value">{{summaryReportData.LiabilitiesDebt}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>-->

                <div class="block block-strong inset" style="padding: 0; overflow: hidden">
                  <div class="list inline-labels no-hairlines" style="margin: 0;">
                    <ul>
                      <li>
                        <a class="item-link smart-select smart-select-init" data-open-in="sheet" data-close-on-select="true">
                            <select name="ReportType">
                              {{#each reportTypeList}}
                              <option value="{{id}}">{{text}}</option>
                              {{/each}}
                            </select>
                            <div class="item-content">
                              <div class="item-inner">
                                <div class="item-title">Báo cáo theo</div>
                              </div>
                            </div>
                          </a>
                      </li>
                      <li>
                        <div class="item-content item-input">
                          <div class="item-inner">
                            <div class="item-title item-label">Phạm vi</div>
                            <div class="item-input-wrap">
                              <input name="ReportRange" type="text" placeholder="Ngày báo cáo" readonly="readonly" id="reportDate" @change="onReportDateChange" style="text-align: right;"/>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="autocomplete Product">
                        <div class="item-link smart-select item-content" href="#">
                          <div class="item-inner" style="display: flex;">
                            <div class="item-title">Sản phẩm</div>
                            <div class="item-after text-color-blue">{{text Product coalesce="Chọn..."}}</div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-virtual-list="true" data-close-on-select="true" data-popup-swipe-to-close="true" data-scroll-yo-selected-item="true">
                            <select name="Unit">
                            <option value="">Chọn</option>
                              {{#each unitList}}
                              <option value="{{id}}">{{text}}</option>
                              {{/each}}
                            </select>
                            <div class="item-content">
                              <div class="item-inner">
                                <div class="item-title">Đơn vị tính</div>
                                <div class="item-after text-color-blue"></div>
                              </div>
                            </div>
                          </a>
                      </li>
                    </ul>
                  </div>
                </div>

                
                <div style="padding-top: 0px; padding-bottom: 0">
                  <div class="block-title" style="margin-top: 0.5rem">Phân tích giá nhập</div>
                  <div class="block block-strong inset" style="margin-bottom: 0;">
                    <canvas id="purchaseActivityChart" width="300" height="200"></canvas>
                  </div>
                </div>

                <div style="padding-top: 0px">
                  <div class="block-title">Top nhà cung cấp</div>
                  <div class="list media-list inset">
                    <ul>
                      {{#each topSupplierList}}
                      <li data-name="remove-chat-room-member" data-id="{{Employee}}">
                        <a class="item-content item-link">
                          <div class="item-media">
                            {{#js_if "this.Avatar"}}
                            <div class="list-item-img" style="width: 44px; height: 44px; background-image: url({{js "this.Avatar &&  this.Avatar.SmallImage"}});"></div>
                            {{else}}
                            <div class="list-item-img" style="width: 44px; height: 44px">
                              <i style="font-size: 16px" class="f7-icons">person_fill</i>
                            </div>
                            {{/js_if}}
                          </div>
                          <div class="item-inner">
                            <div class="item-title-row">
                              <div class="item-title">{{ObjectName}}</div>
                              <div class="item-after">{{#if RefIcon}}<img style="height: 12px;" src="{{RefIcon}}">{{/if}}</div>
                            </div>
                            <div class="item-subtitle" style="color: var(--ion-color-primary)">{{PurchaseAmount}}</div>
                          </div>
                        </a>
                      </li>
                      {{/each}}
                    </ul>
                  </div>
                </div> 
              
              </div>
            </div>
        `,
        style: /*css*/`
          .warehouse-container-list .find-order {
            font-size: 16px;
            font-weight: bold;
          }
          .warehouse-container-list .action-bar {
            color: var(--f7-block-strong-text-color);
            padding-top: var(--f7-block-padding-vertical);
            padding-bottom: var(--f7-block-padding-vertical);
            background-color: var(--f7-block-strong-bg-color);
          }

          .page.purchase-price-statistics .card {
            margin-left: 0; 
            margin-right: 0
          }
          .page.purchase-price-statistics .card .card-content {
            padding: 0.5rem;
          }
          .page.purchase-price-statistics .card .card-content-wrap {
            display: flex; flex-direction: row
          }
          .page.purchase-price-statistics .card .icon-wrap {
            padding-right: 0.5rem;
          }
          .page.purchase-price-statistics .card .icon-wrap button {
            width: 3rem; height: 3rem
          }
          .page.purchase-price-statistics .card .label-wrap {

          }
          .page.purchase-price-statistics .card .label-wrap {
            display: flex; flex-direction: column
          }
          .page.purchase-price-statistics .card .label-wrap .label-text {
            font-weight: bold; font-size: 1rem
          }
          .page.purchase-price-statistics .card .label-wrap .label-value {
            font-weight: bold;
            font-size: 0.6rem;
            white-space: nowrap;
          }

        `,
        data() {
          return {
            title: $this.title,
            // reminder: {
            //   No: '234234',
            // },
            priceReport: { Details: [] },
            summaryReportData: {

            },
            reportDate: $this.reportDate.getDate() + '/' + ($this.reportDate.getMonth() + 1) + '/' + $this.reportDate.getFullYear(),
            dateReportList: [],
            productGroupList: [],
          };
        },
        methods: {
          onReportDateChange(e) {
            // const self: F7ComponentContextExtend = this;
            // console.log(e.currentTarget.value);
            // const inputDate = e.currentTarget.value.split('/');
            // $this.reportDate = new Date(inputDate[2], inputDate[1] - 1, inputDate[0]);
            // $this.commonService.showPreloader();
            // self.refresh().then(rs => {
            //   $this.commonService.hidePreloader();
            // }).catch(err => {
            //   $this.commonService.hidePreloader();
            // });
          },
          gotoProfile(e) {
          },
          // Price report
          openVoucher(e, id?: string) {
            const self: F7ComponentContextExtend = this;
            id = id || self.$(e.target).closest('li').data('id') || 'new';

            // if ($this.commonService.frameSocket.isFrameMode && id && id !== 'new') {
            //   $this.commonService.frameSocket.emit('request-open-voucher', { id: id, type: 'PRICEREPORT' });
            // } else {
            $this.rootServices.navigate('/purchase/order/' + id, {
              context: {
                backTitle: $this.title,
                textColorClass: self.textColorClass,
                // memberInfo: $this.currentState.chatRoom.memberList$.getValue().find(f => f.id === id),
                // chatRoom: self.$route.context.chatRoom,
                // reminderList$: self.reminderList$,
              }
            });
            // }
          },
          goto(e) {
            const self: F7ComponentContextExtend = this;
            const url = self.$(e.target).closest('.goto').data('url');
            $this.rootServices.navigate(url);
          },
          chooseOne(e) {
            const self: F7ComponentContextExtend = this;
            const id = self.$(e.target).closest('li').data('id');
            self.$route.context['onChoose'] && self.$route.context['onChoose'](self.productList.find(f => f.Code === id));
          },
          chooseProduct(e) {

          },
          async refresh(e, done) {
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state['main'];
            let doneTimeout = null;
            if (done) {
              doneTimeout = setTimeout(() => {
                done();
              }, 10000);
            };

            let reportType = currentState.reportTypeList.find(f => f.id == currentState.reportQuery.type)?.reportType;
            let pages = [];
            const range = currentState.reportQuery.range;
            if (range && range.length < 2 || !reportType) {
              done && done();
              return;
            }
            const dateRange: Date[] = [range[0], range[1]];
            const productGroups = currentState.reportQuery.productGroups;
            const unit = currentState.reportQuery.unit;
            const product = currentState.reportQuery.product;
            const extendProductsQuery = {
              ...(productGroups.length > 0 ? { eq_ProductGroup: `[${productGroups.join(',')}]` } : {}),
            }

            let fromDate = dateRange && dateRange[0] && (new Date(dateRange[0].getFullYear(), dateRange[0].getMonth(), dateRange[0].getDate(), 0, 0, 0, 0)).toISOString() || null;
            let toDate = dateRange && dateRange[1] && new Date(dateRange[1].getFullYear(), dateRange[1].getMonth(), dateRange[1].getDate(), 23, 59, 59, 999).toISOString() || null;

            // Report summary
            let summaryReport = await $this.rootServices.apiService.getPromise<any[]>('/accounting/reports', {
              reportSummary: true,
              eq_Accounts: "[156,152,153,632,6417,331]",
              skipHeader: true,
              branch: pages,
              toDate: toDate,
              fromDate: fromDate,
              entryGroup: 'PURCHASE',
              limit: 'nolimit',
              ...extendProductsQuery
            });
            let summaryReportData: any = {
              // Cash: 0,
              // Revenues: 0,
              // DecreaseRevenues: 0,
              // DecreaseRevenuesByReturns: 0,
              // DecreaseRevenuesByDiscount: 0,
              // CustomerReceivableDebt: 0,
              // CostOfGoodsSold: 0,
              // GrossProfit: 0,
              // NumOfVouchers: 0,
              PurchaseAmount: 0,
              PurchaseCost: 0,
              LiabilitiesDebt: 0,
            };

            for (const reportItem of summaryReport) {
              // if (/^111/.test(reportItem.Account)) summaryReportData.Cash += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              // if (/^112/.test(reportItem.Account)) summaryReportData.CashInBank += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              if (/^156|152|153|632/.test(reportItem.Account)) {
                summaryReportData.PurchaseAmount += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^6417/.test(reportItem.Account)) {
                summaryReportData.PurchaseCost += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^331/.test(reportItem.Account)) {
                summaryReportData.LiabilitiesDebt += (reportItem.GenerateCredit - reportItem.GenerateDebit);
              }
            }

            self.$setState({
              // Summary data
              summaryReportData: {
                // Cash: $this.rootServices.currencyPipe.transform(summaryReportData.Cash, 'VND'),
                PurchaseAmount: $this.rootServices.currencyPipe.transform(summaryReportData.PurchaseAmount, 'VND'),
                PurchaseCost: $this.rootServices.currencyPipe.transform(summaryReportData.PurchaseCost, 'VND'),
                LiabilitiesDebt: $this.rootServices.currencyPipe.transform(summaryReportData.LiabilitiesDebt, 'VND'),
              },
            });



            /** Load data for purchase activetity */
            const eqUnit = $this.commonService.getObjectId(unit);
            const eqProduct = $this.commonService.getObjectId(product);
            const relativeObjectIds = [];
            if (!!(eqProduct && eqUnit)) {
              let statisticsData = await $this.rootServices.apiService.getPromise<any[]>('/accounting/statistics', { includeObject: true, eq_Account: "[1561,152,153,632]", statisticsCost: true, branch: pages, reportBy: reportType, ge_VoucherDate: fromDate, le_VoucherDate: toDate, eq_Product: eqProduct, eq_ProductUnit: eqUnit, limit: 'nolimit', entryGroup: 'PURCHASE', groupBy: '[Object]' });
              let linesData: any = {};
              let timeline = [];
              for (let entry of statisticsData) {
                entry.Label = $this.makeStaticLabel(entry, reportType);
                entry.Timeline = $this.makeTimeline(entry, reportType);
                entry.Value = entry.DebitPrice;
                const objectId = $this.commonService.getObjectId(entry.Object);
                if (relativeObjectIds.findIndex(f => f == objectId) < 0) {
                  relativeObjectIds.push(objectId);
                }
                if (!linesData[objectId]) {
                  linesData[objectId] = [];
                }
                linesData[objectId].push(entry);
                timeline.push(entry.Timeline);
              }
              timeline = [
                ...new Set(
                  timeline.sort(),
                )
              ];
              let labels = [];
              let mergeData2 = timeline.map((t, index) => {
                for (const lineId in linesData) {
                  const lineData = linesData[lineId].find(f => f.Timeline == t);
                  if (lineData && lineData.Label) {
                    labels.push(lineData.Label);
                    break;
                  }
                }
                const timelinePoint = {
                  Label: t,
                };
                for (const lineId in linesData) {
                  const prevLineData = index > 0 ? linesData[lineId].find(f => f.Timeline == timeline[index - 1]) : null;
                  let lineData = linesData[lineId].find(f => f.Timeline == t);
                  if (!lineData) {
                    linesData[lineId].push({
                      Timeline: t,
                      Value: prevLineData && prevLineData.Value || 0,
                    });
                  }
                  timelinePoint[lineId] = linesData[lineId].find(f => f.Timeline == t) || { Value: 0 };
                }
                return timelinePoint;
              });

              const colors = [
                $this.rootServices.themeColors.default.succuess,
                $this.rootServices.themeColors.default.primary,
                $this.rootServices.themeColors.default.info,
                $this.rootServices.themeColors.default.warning,
                $this.rootServices.themeColors.default.danger,
              ]

              const datasets = Object.keys(linesData).map(lineId => {
                const color = colors.pop();
                return {
                  label: $this.commonService.getObjectText(linesData[lineId][0]['Object']),
                  data: mergeData2.map(point => point[lineId]['Value']),
                  borderColor: color || $this.rootServices.themeColors.default.primary,
                  // backgroundColor: $this.rootServices.themeColors.dim10.primary,
                  pointRadius: 5,
                  pointHoverRadius: 10,
                };
              });

              self.costAndRevenueStatisticsData = {
                labels: labels,
                datasets: datasets,
              };

              if (!self.purchaseActivityChart) {
                self.purchaseActivityChart = self.purchaseActivityChart || new Chart('purchaseActivityChart', {
                  type: 'line',
                  data: self.costAndRevenueStatisticsData as any,
                  options: {
                    scales: {
                      y: {
                        beginAtZero: true
                      }
                    }
                  }
                });
              } else {
                self.purchaseActivityChart.data = self.costAndRevenueStatisticsData;
                self.purchaseActivityChart.update('active');
              }
            }
            // End



            // Report top
            let topSupplierList = [];
            // let topCustomerList = [];
            let topGoodsList = [];
            await $this.rootServices.apiService.getPromise<any>('/accounting/reports', { reportPurchaseFromSupplier: true, branch: pages, fromDate: fromDate, toDate: toDate, sort_DebitGenerate: 'desc', entryGroup: 'PURCHASE', limit: 100, ...extendProductsQuery, eq_Object: '[' + relativeObjectIds.join(',') + ']' }).then(rs => {
              topSupplierList = rs.filter(f => f.GenerateDebit - f.GenerateCredit > 0).map(item => {
                item.PurchaseAmount = $this.rootServices.currencyPipe.transform((item.GenerateDebit - item.GenerateCredit) || 0, 'VND');
                return item;
              });
              console.log(rs);
            });
            // await $this.rootServices.apiService.getPromise<any>('/accounting/reports', { reportPurchaseFromGoods: true, branch: pages, fromDate: fromDate, toDate: toDate, sort_DebitGenerate: 'desc', entryGroup: 'PURCHASE', limit: 100, ...extendProductsQuery }).then(rs => {
            //   topGoodsList = rs.filter(f => f.GenerateDebit - f.GenerateCredit > 0).map(item => {
            //     item.PurchaseAmount = $this.rootServices.currencyPipe.transform((item.GenerateDebit - item.GenerateCredit) || 0, 'VND');
            //     return item;
            //   });
            //   console.log(rs);
            // });

            self.$setState({
              // Summary data
              // summaryReportData: {
              //   Cash: $this.rootServices.currencyPipe.transform(summaryReportData.Cash, 'VND'),
              //   Revenues: $this.rootServices.currencyPipe.transform(summaryReportData.Revenues, 'VND'),
              //   DecreaseRevenuesByReturns: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByReturns, 'VND'),
              //   DecreaseRevenuesByDiscount: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByDiscount, 'VND'),
              //   CustomerReceivableDebt: $this.rootServices.currencyPipe.transform(summaryReportData.CustomerReceivableDebt, 'VND'),
              // },
              // Top data
              topSupplierList: topSupplierList,
              // topCustomerList: topCustomerList,
              // topGoodsList: topGoodsList,
            });
            done && done();
            return true;
          },
        },
        on: {
          // pageMounted(e, page) {
          //     console.log('page mounted');
          // },
          pageInit(e, page: F7Page) {
            console.log('page init');
            const self: F7ComponentContextExtend = this;
            // Loading flag
            let allowInfinite = true;
            $this.onComponentInit({ instance: self }, 'main', null, page).then(currentState => {
              // self.refresh();
            });

          },
          // pageBeforeIn(e, page) {
          //     console.log('page before in');
          //     const self: F7ComponentContextExtend = this;
          //     self.refresh();
          // },
          pageAfterIn(e, page) {
            console.log('page after in');
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state[self.$route.params.id];
            if (e['detail']?.from == 'previous') {
              self.refresh();
            }
          },
          // pageBeforeOut(e, page) {
          //     console.log('page before out');
          // },
          // pageAfterOut(e, page) {
          //     console.log('page after out');
          // },
          // pageBeforeUnmount(e, page) {
          //     console.log('page before unmount');
          // },
          // pageBeforeRemove(e, page) {
          //     console.log('page before remove');
          // },
          pageBeforeRemove(e, page) {
            console.log('[page event] before remove', page.route.url);
            const self: F7ComponentContextExtend = this;
            // const starmtSelectRoles = self.$app.smartSelect.get('.smart-select');
            // starmtSelectRoles.destroy();
          },
        },
      },
    };
  }
}
